/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterEligibility = {
    filterType: CompositeSearchEnhancedFilterEligibility.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<string>;
};

export namespace CompositeSearchEnhancedFilterEligibility {

    export enum filterType {
        ELIGIBILITY1 = 'eligibility1',
        ELIGIBILITY2 = 'eligibility2',
        ELIGIBILITY3 = 'eligibility3',
    }


}

